import { Navigate } from 'react-router-dom';
import { useProjectStore } from '@/store/projectStore';

type Props = {
  to?: string; // ex: "carte", "boxs", "logements"...
};

export function NavigateToSelectedProject({ to }: Props) {
  const selectedProjectId = useProjectStore((s) => s.selectedProjectId);

  if (!selectedProjectId) {
    return <Navigate to="/dashboard" replace />;
  }

  const target = to ? `/dashboard/${selectedProjectId}/${to}` : `/dashboard/${selectedProjectId}`;
  return <Navigate to={target} replace />;
}

